(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var selector = '.encabezado__desplegable';

    function cerrarDesplegables(excepto) {
      document.querySelectorAll(selector + '[open]').forEach(function (d) {
        if (d !== excepto) d.removeAttribute('open');
      });
    }

    document.addEventListener(
      'toggle',
      function (e) {
        if (e.target.matches && e.target.matches(selector) && e.target.open) cerrarDesplegables(e.target);
      },
      true
    );

    document.addEventListener('click', function (e) {
      if (!e.target.closest(selector)) cerrarDesplegables();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var abierto = document.querySelector(selector + '[open]');
      if (!abierto) return;
      abierto.removeAttribute('open');
      abierto.querySelector('summary').focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ideas-regalo"] && !Shopify.designMode) return;
  try {
    
  // Ideas de regalo carousel (desktop, setting "Carrusel en escritorio").
  // Previous / next scroll one page (4 ideas) and are disabled at the ends;
  // the mouse can drag the row (trackpads scroll it natively); a drag never
  // opens the link under the pointer. No autoplay. Smooth only when motion
  // is allowed (html.animar). Without this script the row still scrolls.
  (function () {
    function iniciar(raiz) {
      var lista = raiz.querySelector('[data-ideas-lista]');
      var controles = raiz.querySelector('[data-ideas-controles]');
      var anterior = raiz.querySelector('[data-ideas-anterior]');
      var siguiente = raiz.querySelector('[data-ideas-siguiente]');
      if (!lista || !controles || !anterior || !siguiente) return;

      function conMovimiento() {
        return document.documentElement.classList.contains('animar');
      }

      function actualizar() {
        var maximo = lista.scrollWidth - lista.clientWidth;
        // nothing to scroll (few ideas): no buttons
        controles.hidden = maximo <= 1;
        anterior.disabled = lista.scrollLeft <= 1;
        siguiente.disabled = lista.scrollLeft >= maximo - 1;
      }

      function mover(sentido) {
        lista.scrollBy({ left: sentido * lista.clientWidth, behavior: conMovimiento() ? 'smooth' : 'auto' });
      }

      anterior.addEventListener('click', function () {
        mover(-1);
      });
      siguiente.addEventListener('click', function () {
        mover(1);
      });

      var pendiente = false;
      lista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(function () {
          pendiente = false;
          actualizar();
        });
      });
      window.addEventListener('resize', actualizar);

      // Mouse drag (touch and pen keep the native scrolling)
      var arrastre = null;
      var arrastro = false;
      lista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        arrastre = { x: e.clientX, inicio: lista.scrollLeft };
        arrastro = false;
      });
      lista.addEventListener('pointermove', function (e) {
        if (!arrastre) return;
        var dx = e.clientX - arrastre.x;
        if (!arrastro && Math.abs(dx) < 6) return;
        if (!arrastro) {
          arrastro = true;
          lista.classList.add('ideas__lista--arrastrando');
          if (lista.setPointerCapture) lista.setPointerCapture(e.pointerId);
        }
        lista.scrollLeft = arrastre.inicio - dx;
      });
      function soltar() {
        if (!arrastre) return;
        arrastre = null;
        if (!arrastro) return;
        // snap to the nearest idea once released
        lista.classList.remove('ideas__lista--arrastrando');
        var items = lista.children;
        var cerca = 0;
        var mejor = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].offsetLeft - lista.offsetLeft - lista.scrollLeft);
          if (d < mejor) {
            mejor = d;
            cerca = items[i].offsetLeft - lista.offsetLeft;
          }
        }
        lista.scrollTo({ left: cerca, behavior: conMovimiento() ? 'smooth' : 'auto' });
      }
      lista.addEventListener('pointerup', soltar);
      lista.addEventListener('pointercancel', soltar);
      // a drag is not a click on the idea under the pointer
      lista.addEventListener(
        'click',
        function (e) {
          if (arrastro) {
            e.preventDefault();
            e.stopPropagation();
            arrastro = false;
          }
        },
        true
      );
      lista.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      actualizar();
    }

    var raices = document.querySelectorAll('[data-ideas-carrusel]');
    for (var i = 0; i < raices.length; i++) iniciar(raices[i]);
  })();

  } catch(e) { console.error(e); }
})();
})();
